import { isPortfolioOptimizationEvidence } from "../contracts/portfolioOptimizationDecisionEvidence";

export const PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY = "portfolio-optimization-decision-evidence:v1";

const availableStorage = (storage) => storage || (typeof window !== "undefined" ? window.sessionStorage : null);

export function storePortfolioOptimizationEvidence(evidence, storage) {
  if (!isPortfolioOptimizationEvidence(evidence)) return false;
  try {
    availableStorage(storage)?.setItem(PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY, JSON.stringify(evidence));
    return Boolean(availableStorage(storage));
  } catch (_) {
    return false;
  }
}

export function restorePortfolioOptimizationEvidence(storage) {
  const target = availableStorage(storage);
  if (!target) return null;
  try {
    const serialized = target.getItem(PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY);
    if (!serialized) return null;
    const evidence = JSON.parse(serialized);
    if (!isPortfolioOptimizationEvidence(evidence)) {
      target.removeItem(PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY);
      return null;
    }
    return evidence;
  } catch (_) {
    try { target.removeItem(PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY); } catch (_) {}
    return null;
  }
}

export function clearPortfolioOptimizationEvidence(storage) {
  try { availableStorage(storage)?.removeItem(PORTFOLIO_OPTIMIZATION_EVIDENCE_STORAGE_KEY); } catch (_) {}
}
